import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from "./Pages/Services";
import Contact from "./Pages/Contact";
import Blogs from "./Pages/Blogs";
import CaseStudies from "./Pages/Case-studies";
import Testimonial from "./Pages/Testimonial";
import CaseStudyDetail from "./Pages/CaseStudyDetail";
import BlogDetail from "./Pages/BlogDetail";
import Portfolio from "./Pages/Portfolio";
import Portfoliodetail from "./Pages/Portfoliodetail";
import GetCosting from "./Pages/GetCosting";
import Privacy from "./Pages/Privacy";
import Terms from "./Pages/Terms";
import Career from "./Pages/Career";


import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop/>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/case-study/:id" element={<CaseStudyDetail />} />
        <Route path="/blogdetail/:id" element={<BlogDetail />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio/:slug" element={<Portfoliodetail />} />
        <Route path="/get_costing" element={<GetCosting />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/career" element={<Career />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;